import { axiosInstance } from "./interceptors";
import {
  eventAndRegistrationQuestionsState,
  registerObject,
  reqHeader,
  postLink,
  EventSettingsResponse,
  ParticipantPatchRequestData,
} from "../types/types";
import * as config from "./config";
import storeService from "./storage";

const create = async (data: { [key: string]: string | string[] }) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/new`;
  return await axiosInstance({ method: "POST", url, data, headers });
};

const getEventState = async (id: string) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/createstate/${id}`;
  return await axiosInstance({ url, headers });
};

const getAll = async (obj: { date: string; limit: string }) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/events/${obj.date}/${obj.limit}`;
  return await axiosInstance({ url, headers });
};

const saveRegister = async (data: registerObject, goto: string) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/register/save`;
  const result = await axiosInstance({ method: "POST", url, data, headers });
  return { data: result.data, status: result.status, url: goto };
};

const saveEventRegistrationQuestions = async (
  data: eventAndRegistrationQuestionsState
) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/form/save`;
  return await axiosInstance({ method: "POST", url, data, headers });
};

const getEventDetails = async (id: string) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/details/${id}`;
  return await axiosInstance({ url, headers });
};

const getParticipants = async (id: string) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/registered/${id}`;
  return await axiosInstance({ url, headers });
};

const postFormLink = async (data: postLink) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/link`;
  return await axiosInstance({ method: "POST", url, data, headers });
};

const getLinkSuggestion = async () => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/link`;
  return await axiosInstance({ url, headers });
};

const getEventsLyyti = async (locale: string) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/ext/customerevents`;
  const result = await axiosInstance({ url, headers });
  return { data: result.data, status: result.status, locale };
};

const getParticipantsLyyti = async (id: number) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/ext/eventparticipants/${id}`;
  return await axiosInstance({ url, headers });
};

const getLyytikey = async () => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/ext/lyytikey`;
  return await axiosInstance({ url, headers });
};

const getDbKeys = async (): Promise<{
  data: EventSettingsResponse;
  status: number;
}> => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/settings`;
  return await axiosInstance({ url, headers });
};

const getParticipantDetails = async (
  subEventId: string,
  uuid: string,
  eventId: string
) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/registereddetails/${subEventId}/${uuid}`;
  const result = await axiosInstance({ url, headers });
  return { data: result.data, status: result.status, eventId };
};

const saveParticipantChanges = async (
  data: ParticipantPatchRequestData,
  eventId: string
) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/participant`;
  const result = await axiosInstance({ method: "PATCH", url, data, headers });
  return { data: result.data, status: result.status, eventId };
};

const getSubEventDetails = async (subEventId: string) => {
  const Jwt = storeService.getString("jwt");
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/subevent/${subEventId}`;
  return await axiosInstance({ url, headers });
};

const createSubEvent = async (eventId: string) => {
  const Jwt = storeService.getString("jwt");
  const data = { eventId };
  const headers: reqHeader = { Jwt };
  const url = `${config.baseUrl}/event/subevent`;
  return await axiosInstance({ method: "POST", url, data, headers });
};

//TODO: Extract all participant-related requests to own service-module

const eventService = {
  create,
  createSubEvent,
  getEventState,
  getLinkSuggestion,
  saveEventRegistrationQuestions,
  getAll,
  saveRegister,
  getEventDetails,
  getParticipants,
  postFormLink,
  getEventsLyyti,
  getParticipantsLyyti,
  getLyytikey,
  getDbKeys,
  getParticipantDetails,
  saveParticipantChanges,
  getSubEventDetails,
};

export default eventService;
